import ServiceBase from "../service/ServiceBase";

const ENDPOINTS = {
  ALL_PRODUCTS: "/product/all",
  PRODUCT_DETAILS: "/product/productDetail",
  BRAND_LIST: "/product/brandsListing",
  CATEGORY_LIST: "/product/categoryListing",
  CATEGORIES: "/product/categoryListing?sort=ordering_number&order=ASC",
  NEW_ARRIVAL_LIST: "/product/newArrivals",
};

class ProductManagementService extends ServiceBase {
  getAllProducts(filterParams = {}) {
    return this._handleAPICall(ENDPOINTS.ALL_PRODUCTS, filterParams, "get", true, true);
  }
  getProductDetails(id) {
    return this._handleAPICall(ENDPOINTS.PRODUCT_DETAILS, { id }, "get", true);
  }
  getProductBrandListing() {
    return this._handleAPICall(ENDPOINTS.BRAND_LIST, "get");
  }
  getProductCategoryListing() {
    return this._handleAPICall(ENDPOINTS.CATEGORY_LIST, "get");
  }
  getProductCategories() {
    return this._handleAPICall(ENDPOINTS.CATEGORIES, "get");
  }
  getProductNewArrivalListing() {
    return this._handleAPICall(ENDPOINTS.NEW_ARRIVAL_LIST, "get");
  }
}

const productService = new ProductManagementService();
export default productService;
